// eslint-disable-next-line import/no-anonymous-default-export
export default {
  copyFromMaps: 'You can copy from Google Maps'
};
